import { render, staticRenderFns } from "./RefContactSliderSelector.vue?vue&type=template&id=589bde5f&"
import script from "./RefContactSliderSelector.vue?vue&type=script&lang=ts&"
export * from "./RefContactSliderSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RefContactSliderSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports